/* global jQuery, elementorFrontend */

/**
 * Set cart count from state.
 */
function updatePrice( widget ) {
	if( 'undefined' !== typeof whippetState && whippetState.isWholesale ) {
		const priceValue = widget.querySelector( '.price-value' );

		if( priceValue && priceValue.dataset.supplierPrice ) {
			priceValue.innerHTML = priceValue.dataset.supplierPrice;
		}
	}
}

// Update prices on state change
document.addEventListener( 'whippetStateChanged', () => {
	document.querySelectorAll( '.whippet-product-loop-price' ).forEach( widget => updatePrice );
} )

// Update prices on widget ready for widgets loaded after state change
jQuery(window).on( 'elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction( 'frontend/element_ready/whippet-product-loop-price.default', $scope => {
		updatePrice( $scope[0] );
	} );
} );
